import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { hasEnabledFeature, hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ fields }) => {
  return {
    form_getEmail: {
      [SERVICE_PROVIDERS.EDVIR]: () => ({
        add: fields.phone.replace(/[-]/g, '') + '@dvironly.com',
        edit: `${fields.phone.replace(/[-]/g, '')}+${fields.id}@dvironly.com`,
      }),
      default: () => false,
    },
    form_driverStatusViewMore: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    form_nonDotTrip: {
      [SERVICE_PROVIDERS.CLUTCH]: () => true,
      default: () => !hasEnabledFeature('dotTripEnabled'),
    },
    form_submitModal: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    schema_email: {
      [SERVICE_PROVIDERS.EDVIR]: () => true,
      default: () => false,
    },
    schema_hireDate: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    render_isDisabled: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      default: () => false,
    },
    RTFMuser: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_hireDate: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    render_drivers: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_mechanic: {
      [SERVICE_PROVIDERS.SIMPLEX]: () => true,
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.TRACKIT]: () => true,
      [SERVICE_PROVIDERS.FT]: () => true,
      [SERVICE_PROVIDERS.HCSS]: () => true,
      [SERVICE_PROVIDERS.PATRIOT]: () => true,
      [SERVICE_PROVIDERS.TTS]: () => true,
      default: () => false,
    },
    render_userCredentials: {
      [SERVICE_PROVIDERS.EDVIR]: () => true,
      default: () => false,
    },
    render_employeeId: {
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      default: () => true,
    },
    render_isDvirOnly: {
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      default: () => true,
    },
    render_exemptFromUsingELD: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      default: () => true,
    },
    render_departments: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    render_vehicleForMechanic: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      default: () => true,
    },
    render_documents: {
      [SERVICE_PROVIDERS.SIMPLEX]: () => false,
      default: () => true,
    },

    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
